import React, { useState } from 'react';
import '../App.css';

const API_URL = window.location.origin;

export function TelegramAuthStart({ onCodeSent }) {
    const [internalId, setInternalId] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!internalId.trim()) {
            setError('Введите ваш внутренний ID');
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await fetch(`${API_URL}/api/auth/telegram/request-code`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ internalId: parseInt(internalId) })
            });

            const data = await response.json();

            if (data.success) {
                onCodeSent(internalId);
            } else {
                setError(data.error || 'Ошибка при отправке кода');
            }
        } catch (error) {
            console.error('Ошибка:', error);
            setError('Ошибка соединения с сервером');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header">
                        <h1>HydraVPN</h1>
                        <p>Введите ваш внутренний ID</p>
                        <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.5)' }}>
                            ID можно найти в боте после команды /start
                        </p>
                    </div>

                    {error && <div className="auth-error">{error}</div>}

                    <form onSubmit={handleSubmit} className="auth-form">
                        <div className="form-group">
                            <input
                                type="number"
                                placeholder="Внутренний ID"
                                value={internalId}
                                onChange={(e) => setInternalId(e.target.value)}
                                required
                            />
                        </div>

                        <button type="submit" className="auth-button" disabled={loading}>
                            {loading ? 'Отправка...' : 'Получить код в Telegram'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}